<template>
  <div class="h-100 d-flex align-center justify-space-between text-medium-emphasis">
    <!-- 👉 Footer: left content -->
    <span class="d-flex align-center">
      &copy;
      {{ new Date().getFullYear() }}
      Samurai Rekrutmen
    </span>
    <!-- 👉 Footer: right content -->
    <span class="d-md-flex gap-x-4 text-primary d-none">
      <a
        href=""
        target="noopener noreferrer"
      >Privacy Policy</a>
      <a
        href=""
        target="noopener noreferrer"
      >Terms</a>
      <a
        href=""
        target="noopener noreferrer"
      >Contact</a>
    </span>
  </div>
</template>
